import { useState } from "react";
import { Link } from "react-router-dom";
import api, { formatApiError } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { APP_LOGO } from "@/lib/constants";
import { ArrowLeft, MailCheck } from "lucide-react";

export default function ForgotPassword() {
  const [email, setEmail] = useState("");
  const [sent, setSent] = useState(false);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  const submit = async () => {
    setError(""); setLoading(true);
    try { await api.post("/auth/forgot-password", { email }); setSent(true); }
    catch (e) { setError(formatApiError(e.response?.data?.detail)); }
    finally { setLoading(false); }
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-cream px-6">
      <div className="w-full max-w-sm animate-fade-up">
        <div className="flex justify-center mb-8"><img src={APP_LOGO} alt="Primrose" className="h-28 w-auto object-contain" /></div>
        {sent ? (
          <div className="card-lux p-6 text-center">
            <MailCheck className="w-12 h-12 text-emerald-500 mx-auto mb-3" strokeWidth={1.4} />
            <h3 className="font-heading text-2xl text-burgundy mb-1">Cek email Anda</h3>
            <p className="text-sm text-[#7A7A7A]">Jika email terdaftar, kami telah mengirim tautan reset password. Tautan berlaku 1 jam.</p>
            <Link to="/login" className="inline-block mt-5 text-sm text-burgundy underline" data-testid="back-to-login">Kembali ke login</Link>
          </div>
        ) : (
          <div className="card-lux p-6">
            <h3 className="font-heading text-2xl text-[#1A1A1A] mb-1">Lupa Password</h3>
            <p className="text-sm text-[#7A7A7A] mb-5">Masukkan email akun Anda untuk menerima tautan reset.</p>
            <Label className="text-xs font-semibold text-[#4A4A4A] mb-1.5 block">Email</Label>
            <Input data-testid="forgot-email" type="email" value={email} onChange={(e) => setEmail(e.target.value)} className="bg-white mb-3" />
            {error && <p className="text-sm text-red-600 mb-3">{error}</p>}
            <Button onClick={submit} disabled={loading || !email} data-testid="forgot-submit" className="w-full bg-burgundy hover:bg-burgundy-dark text-white rounded-full py-6">{loading ? "Mengirim..." : "Kirim Tautan Reset"}</Button>
            <Link to="/login" className="flex items-center justify-center gap-1 mt-4 text-sm text-[#7A7A7A] hover:text-burgundy"><ArrowLeft className="w-4 h-4" />Kembali ke login</Link>
          </div>
        )}
      </div>
    </div>
  );
}
